module.exports = __webpack_public_path__ + "img/fashion_67.b04b5b3a.jpg";